import { AxiosInstance } from 'axios';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

interface DoesCustomerHaveCardResponse {
  hasCard: boolean
}

type DoesCustomerHaveCard = (customerId: string, providerId: string) => Promise<ApiResponse<DoesCustomerHaveCardResponse>>;

const doesCustomerHaveCard = (api: AxiosInstance): DoesCustomerHaveCard => {
  return async (customerId: string, providerId: string) => {
    return apiRequest<DoesCustomerHaveCardResponse>(api, {
      method: 'GET',
      url: `/api/custom-booking/customer/${customerId}/has-card/${providerId}`
    });
  }
}

export default doesCustomerHaveCard;
